import AppContext from "AppContext";
import GeneralForm from "components/GeneralForm";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "reactstrap";
import componenteService from "services/ComponenteService";
import { StatusComponenteEnum } from "services/ComponenteService";
import { statusComponenteText } from "services/ComponenteService";

export default function Dados({ data, onChange, formConfig, edit, novo }) {
  const [historico, setHistorico] = useState([])
  const { state } = useContext(AppContext)

  useEffect(() => {
    if (data.id) {
      componenteService.getHistorico(data.id).then(res => {
        if (res.success) {
          setHistorico(res.data)
        }
      })
    }
  }, [data])

  return (
    <>
      <GeneralForm
        config={formConfig}
        data={data}
        onChange={onChange}
        disabled={!edit}
      />
      {!novo && data.status == StatusComponenteEnum.INSTALADO && (
        <>
          <hr />
          <h3>Localização Atual</h3>
          <strong>Cruzamento:</strong> {data.cruzamento.numero} - {data.cruzamento.endereco}<br />
          <strong>Desde:</strong> {data.cruzamento.desde}<br />
          <strong>Garantia até:</strong> {data.cruzamento.garantiaAte}<br />
        </>
      )}
      {!novo && data.pai && (
        <>
          <hr />
          <h3>Componente Pai</h3>
          <strong>QR Code:</strong>{' '}
          <Link to={`/admin/componentes/${data.pai.id}`}>{data.pai.qrCode}</Link>
        </>
      )}
      {!novo && (
        <>
          <hr />
          <h3>Histórico</h3>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Descrição</th>
              </tr>
            </thead>
            <tbody>
              {historico.length == 0 && (
                <tr>
                  <td colSpan={2} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {historico.map((el, index) => (
                <tr key={index}>
                  <td>{el.dataFmt}</td>
                  <td>{el.descricao}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </>
  )
}